import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45f54970"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardComponent',
  props: {
    id: String,
    rotate: Boolean,
    index: Number,
    animate: Boolean,
},
  setup(__props) {

const props = __props;

const factor = 4
const rotFac = 10



const source = computed(() => {
    return "cards/" + props.id + ".svg"
})

const rotation = computed(() => {
    if (!props.rotate) return ""
    return 'rotate(' + (props.rotate ? ((props.index ) * rotFac).toString() : 0) + 'deg) translate(0, ' + (props.index) * 1.5 + 'vh)'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", { hov: __props.animate }]),
    style: _normalizeStyle({ 'left': (__props.index * factor).toString() + 'rem', 'transform': _unref(rotation) })
  }, [
    _createElementVNode("img", { src: _unref(source) }, null, 8, _hoisted_1)
  ], 6))
}
}

})